import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="objective-operator"
export default class extends Controller {
  static targets = ["manual", "upload", "manualButton", "uploadButton", "yearInput", "operatoridInput"]

  connect() {
    this.showManual();
  }
  showManual(event) {
    if(event) event.preventDefault();
    this.manualTarget.style.display = "block";
    this.uploadTarget.style.display = "none";

    // Desactivar los campos de 'upload'
    this.uploadTarget.querySelectorAll('[data-objective-operator-target="yearInput"], [data-objective-operator-target="operatoridInput"]').forEach(input => {
      input.disabled = true;
    });

    // Activar los campos de 'manual'
    this.manualTarget.querySelectorAll('[data-objective-operator-target="yearInput"], [data-objective-operator-target="operatoridInput"]').forEach(input => {
      input.disabled = false;
    });

    this._updateButtonState(this.manualButtonTarget, this.uploadButtonTarget);
  }

  showUpload(event) {
    if(event) event.preventDefault();
    this.manualTarget.style.display = "none";
    this.uploadTarget.style.display = "block";

    // Activar los campos de 'upload'
    this.uploadTarget.querySelectorAll('[data-objective-operator-target="yearInput"], [data-objective-operator-target="operatoridInput"]').forEach(input => {
      input.disabled = false;
    });

    // Desactivar los campos de 'manual'
    this.manualTarget.querySelectorAll('[data-objective-operator-target="yearInput"], [data-objective-operator-target="operatoridInput"]').forEach(input => {
      input.disabled = true;
    });

    this._updateButtonState(this.uploadButtonTarget, this.manualButtonTarget);
  }

  _updateButtonState(activeButton, inactiveButton) {
    activeButton.classList.add(activeButton.dataset.activeClass);
    activeButton.classList.remove(activeButton.dataset.inactiveClass);

    inactiveButton.classList.add(inactiveButton.dataset.inactiveClass);
    inactiveButton.classList.remove(inactiveButton.dataset.activeClass);
  }
}
